<div class="flex flex-col flex-1 w-full h-full bg-gray-100 font-sans overflow-y-auto custom-scrollbar">
    <div class="flex-1 flex items-center justify-center w-full p-6 lg:p-12">
        <div class="bg-white p-10 lg:p-12 rounded-xl shadow-lg w-full max-w-[440px] lg:max-w-[500px] text-center mx-auto transition-all">
            <!-- Language Switcher -->
            <div class="flex justify-end gap-3 mb-4 text-[0.75rem] font-semibold text-gray-400">
                @for (lang of languages; track lang) {
                <span class="cursor-pointer transition-colors duration-200 hover:text-blue-600"
                    [class.text-blue-600]="ts.currentLang() === lang"
                    [class.underline]="ts.currentLang() === lang"
                    [class.underline-offset-4]="ts.currentLang() === lang"
                    (click)="setLanguage(lang)">
                    {{ lang.toUpperCase() }}
                </span>
                }
            </div>

            <!-- Success/Error Messages -->
            @if (message()) {
            <div class="p-3 px-4 rounded mb-6 text-sm text-left bg-green-100 text-green-800 border border-green-700">
                {{ message() }}
            </div>
            }
            @if (error()) {
            <div class="p-3 px-4 rounded mb-6 text-sm text-left bg-red-100 text-red-800 border border-red-700">
                {{ error() }}
            </div>
            }

            <!-- LOGIN MODE -->
            @if (mode() === 'login') {
            @if (schoolName(); as school) {
            <div class="mb-4 p-3.5 bg-blue-50/80 border border-blue-100 rounded-xl text-blue-900 text-sm font-semibold flex items-center justify-center gap-2 animate-fade-in shadow-xs">
                <span class="material-symbols-outlined text-blue-600 text-lg">school</span>
                <span>{{ ts.t('welcome_openolat', { school: school }) }}</span>
            </div>
            }
            <h2 class="text-gray-800 mb-2 text-2xl font-bold">{{ ts.t('login_title') }}</h2>
            <form ngNoForm method="post" [action]="apiBase + '/authorize'" class="mt-6 text-left space-y-4">
                <input type="hidden" name="client_id" [value]="clientId()">
                <input type="hidden" name="redirect_uri" [value]="redirectUri()">
                <input type="hidden" name="scope" [value]="scope()">
                <input type="hidden" name="state" [value]="state()">
                <input type="hidden" name="nonce" [value]="nonce()">
                <input type="hidden" name="response_type" [value]="responseType()">

                <div class="space-y-1">
                    <label for="username" class="block font-medium text-gray-600">
                        {{ ts.t('label_username') }}:
                    </label>
                    <input id="username" name="username" required [value]="username()"
                        (input)="username.set($any($event.target).value)"
                        [placeholder]="ts.t('placeholder_username')"
                        class="w-full p-3 border border-gray-300 rounded focus:outline-none focus:border-blue-600 transition-colors">
                </div>

                <div class="space-y-1">
                    <label for="password" class="block font-medium text-gray-600">
                        {{ ts.t('label_password') }}:
                    </label>
                    <input id="password" type="password" name="password" required [value]="password()"
                        (input)="password.set($any($event.target).value)"
                        [placeholder]="ts.t('placeholder_password')"
                        class="w-full p-3 border border-gray-300 rounded focus:outline-none focus:border-blue-600 transition-colors">
                </div>

                <button type="submit" [disabled]="isLoading() || retryTimer() > 0"
                    class="w-full p-3 mt-4 bg-blue-600 text-white border-0 rounded font-semibold transition-colors flex items-center justify-center gap-2 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed">
                    @if (isLoading()) {
                    <span class="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full font-sans"></span>
                    }
                    @if (retryTimer() > 0) {
                    {{ ts.t('msg_wait', { seconds: retryTimer() }) }}
                    } @else {
                    {{ ts.t('btn_signin') }}
                    }
                </button>
            </form>

            <div class="mt-6 text-sm text-gray-500 flex justify-center items-center gap-2">
                <a (click)="setMode('forgot-password')" class="text-blue-600 hover:underline cursor-pointer transition-all">{{ ts.t('link_forgot_password') }}</a>
                <span class="text-gray-300"> | </span>
                <a (click)="setMode('register')" class="text-blue-600 hover:underline cursor-pointer transition-all">{{ ts.t('link_request_account') }}</a>
            </div>

            <div class="my-6 border-t border-gray-100 relative">
                <span class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white px-4 text-gray-400 text-sm italic">
                    {{ ts.t('text_or') }}
                </span>
            </div>

            <form ngNoForm method="get" [action]="apiBase + '/azure-login'">
                <input type="hidden" name="client_id" [value]="clientId()">
                <input type="hidden" name="redirect_uri" [value]="redirectUri()">
                <input type="hidden" name="state" [value]="state()">
                <input type="hidden" name="nonce" [value]="nonce()">
                <input type="hidden" name="response_type" [value]="responseType()">

                <button type="submit"
                    class="w-full p-3 bg-[#2f2f2f] text-white border-0 rounded font-semibold transition-colors flex items-center justify-center gap-2 hover:bg-black">
                    {{ ts.t('btn_vantage_login') }}
                </button>
            </form>

            <div class="my-6 border-t border-gray-100 relative">
                <span class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white px-4 text-gray-400 text-sm italic">
                    {{ ts.t('text_or') }}
                </span>
            </div>

            <button type="button" disabled
                class="w-full p-3 bg-gray-50 text-gray-400 border border-dashed border-gray-300 rounded font-semibold cursor-not-allowed">
                {{ ts.t('text_coming_soon') }}
            </button>
            }

            <!-- REGISTER MODE (Request) -->
            @if (mode() === 'register' && !registrationCode()) {
            <h2 class="text-gray-800 mb-2 text-2xl font-bold">{{ ts.t('link_request_account') }}</h2>
            <p class="text-gray-600 text-[0.95rem] mb-4">{{ ts.t('msg_enter_email_registration') }}</p>
            <div class="mt-6 text-left space-y-4">
                <div class="space-y-1">
                    <label for="email_reg" class="block font-medium text-gray-600">
                        {{ ts.t('label_username') }}:
                    </label>
                    <input id="email_reg" type="email" [value]="email()"
                        (input)="email.set($any($event.target).value)" 
                        [placeholder]="ts.t('placeholder_username')"
                        class="w-full p-3 border border-gray-300 rounded focus:outline-none focus:border-blue-600 transition-colors">
                </div>
            </div>
            <button class="w-full p-3 mt-6 bg-blue-600 text-white border-0 rounded font-semibold transition-colors flex items-center justify-center gap-2 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed" 
                (click)="onRequestRegistration()" [disabled]="isLoading()">
                @if (isLoading()) {
                <span class="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full font-sans"></span>
                }
                {{ ts.t('btn_request_link') }}
            </button>
            <div class="mt-6 text-sm text-gray-500">
                <a (click)="setMode('login')" class="text-blue-600 hover:underline cursor-pointer transition-all">{{ ts.t('link_back_to_login') }}</a>
            </div>
            }

            <!-- REGISTER MODE (Complete) -->
            @if (mode() === 'register' && registrationCode()) {
            <h2 class="text-gray-800 mb-2 text-2xl font-bold">{{ ts.t('title_complete_registration') }}</h2>
            <p class="text-gray-600 text-[0.95rem] mb-4">{{ ts.t('msg_set_password') }}</p>
            <div class="mt-6 text-left space-y-4">
                <div class="space-y-1">
                    <label for="password_reg" class="block font-medium text-gray-600">
                        {{ ts.t('label_password') }}:
                    </label>
                    <input id="password_reg" type="password" [value]="password()"
                        (input)="password.set($any($event.target).value)"
                        class="w-full p-3 border border-gray-300 rounded focus:outline-none focus:border-blue-600 transition-colors">
                </div>
            </div>
            <button class="w-full p-3 mt-6 bg-blue-600 text-white border-0 rounded font-semibold transition-colors flex items-center justify-center gap-2 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed" 
                (click)="onRegister()" [disabled]="isLoading()">
                @if (isLoading()) {
                <span class="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full font-sans"></span>
                }
                {{ ts.t('btn_activate_account') }}
            </button>
            }

            <!-- FORGOT PASSWORD MODE -->
            @if (mode() === 'forgot-password') {
            <h2 class="text-gray-800 mb-2 text-2xl font-bold">{{ ts.t('link_forgot_password') }}</h2>
            <p class="text-gray-600 text-[0.95rem] mb-4">{{ ts.t('msg_enter_email_reset') }}</p>
            <div class="mt-6 text-left space-y-4">
                <div class="space-y-1">
                    <label for="email_forgot" class="block font-medium text-gray-600">
                        {{ ts.t('label_username') }}:
                    </label>
                    <input id="email_forgot" type="email" [value]="email()"
                        (input)="email.set($any($event.target).value)"
                        class="w-full p-3 border border-gray-300 rounded focus:outline-none focus:border-blue-600 transition-colors">
                </div>
            </div>
            <button class="w-full p-3 mt-6 bg-blue-600 text-white border-0 rounded font-semibold transition-colors flex items-center justify-center gap-2 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed" 
                (click)="onForgotPassword()" [disabled]="isLoading()">
                @if (isLoading()) {
                <span class="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full font-sans"></span>
                }
                {{ ts.t('btn_send_reset_link') }}
            </button>
            <div class="mt-6 text-sm text-gray-500">
                <a (click)="setMode('login')" class="text-blue-600 hover:underline cursor-pointer transition-all">{{ ts.t('link_back_to_login') }}</a>
            </div>
            }

            <!-- RESET PASSWORD MODE (Complete) -->
            @if (mode() === 'reset-password') {
            <h2 class="text-gray-800 mb-2 text-2xl font-bold">{{ ts.t('title_set_new_password') }}</h2>
            <div class="mt-6 text-left space-y-4">
                <div class="space-y-1">
                    <label for="password_reset" class="block font-medium text-gray-600">
                        {{ ts.t('label_password') }}:
                    </label>
                    <input id="password_reset" type="password" [value]="newPassword()"
                        (input)='newPassword.set($any($event.target).value)'
                        class="w-full p-3 border border-gray-300 rounded focus:outline-none focus:border-blue-600 transition-colors">
                </div>
            </div>
            <button class="w-full p-3 mt-6 bg-blue-600 text-white border-0 rounded font-semibold transition-colors flex items-center justify-center gap-2 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed" 
                (click)="onResetPassword()" [disabled]="isLoading()">
                @if (isLoading()) {
                <span class="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full font-sans"></span>
                }
                {{ ts.t('btn_update_password') }}
            </button>
            }

        </div>
    </div>
    <app-footer></app-footer>
</div>